// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SupportRouteImport } from './routes/support'
import { Route as LegalRouteImport } from './routes/legal'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LegalTermsOfUseRouteImport } from './routes/legal/terms-of-use'
import { Route as LegalPrivacyPolicyRouteImport } from './routes/legal/privacy-policy'

const SupportRoute = SupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => rootRouteImport
          })
const LegalRoute = LegalRouteImport.update({
            id: '/legal',path: '/legal',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const LegalTermsOfUseRoute = LegalTermsOfUseRouteImport.update({
            id: '/terms-of-use',path: '/terms-of-use',getParentRoute: () => LegalRoute
          })
const LegalPrivacyPolicyRoute = LegalPrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => LegalRoute
          })





const LegalRouteChildren = {
  LegalPrivacyPolicyRoute: LegalPrivacyPolicyRoute,LegalTermsOfUseRoute: LegalTermsOfUseRoute
}

const LegalRouteWithChildren = LegalRoute._addFileChildren(LegalRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,LegalRoute: LegalRouteWithChildren,SupportRoute: SupportRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)